export default {
	keyColor: '#1076de',
	lightGray: 'rgb(240,240,240)',
	opacityLightGray: 'rgba(245,245,245,0.8)',
	gray: 'rgb(220,220,220)',
	darkGray: '#333',
	opacityDarkGray: 'rgba(51,51,51,0.8)',
	dark: 'rgb(0,0,0,0.8)',
	light: 'rgb(255,255,255,0.8)',
	white: '#fff',
	black: '#000'
};
